import { Action } from '@ngrx/store';
import {startOfDay, subDays} from 'date-fns';

export class Data {
  private clinics?: any = [];
  private treatments?: any = [];
  private practitioners?: any = [];
  private date?: any = [];
  private dateBusy?: any = [];
  private week?: any = [];
  private times?: any = [];
  private details?: any = null;
  private requestUrl?: any = null;
  private day?: any = null;
  private practitionerEvents?: any = null;
  private appointments?: any = null;
  private calendar?: any = null;
  private colors: any = {
    morning: {
      primary: '#ff800a'
    },
    afternoon: {
      primary: '#88cccd'
    },
    evening: {
      primary: '#d8d8d8'
    }
  };
}

export const DATA_REQUEST = 'DATA_UPDATE';
export const DATA_REQUEST_PROCESSING = 'DATA_REQUEST_PROCESSING';
export const DATA_REQUEST_SUCCESS = 'DATA_REQUEST_SUCCESS';
export const DATA_REQUEST_FAILURE = 'DATA_REQUEST_FAILURE';

export class DataAction implements Action {
  public type;

  constructor(
    public payload: Data
  ) {}
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/actions/data.action.ts